<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-toolbar
                    id="supplemental-messages-toolbar"
                    flat
                >
                    <v-row>
                        <v-col
                            cols="6"
                        >
                            <v-toolbar-title>
                                Reports
                            </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <v-btn
                                class="text-subtitle-2 view-history-btn"
                                depressed
                                outlined
                                color="primary"
                                to="/reportList"
                            >
                                <v-icon
                                    left
                                    class="action-icon"
                                >
                                    mdi-history
                                </v-icon>
                                View History
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            >
                <h4>System</h4>
                <span class="report-name mt-3">Centers</span>
                <span class="report-desc">List of One-Call Centers configured on this system.</span>
                <span class="report-name mt-3">System Variables</span>
                <span class="report-desc">Dump of the System_Variables table.</span>
                <span class="report-name mt-3">Company Tickets by Stage</span>
                <span class="report-desc">Company Tickets Counts by Ticket Stage.</span>
                <span class="report-name mt-3">Company Transmissions Summary</span>
                <span class="report-desc">Summary of transmissions by Company.</span>
                <span class="report-name mt-3">Company Attachments Summary</span>
                <span class="report-desc">Summary of Binary Attachment usage by Company.</span>
                <span class="report-name mt-3">Company Ticket Volume</span>
                <span class="report-desc">Tickets received by Company.</span>
            </v-col>
        </v-row> -->
        <!-- <v-row>
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            >
                <h4>Admin</h4>
                <span class="report-name mt-3">Daily Average</span>
                <span class="report-desc">Average ticket volume by weekday.</span>
                <span class="report-name mt-3">Ticket Priority Summary</span>
                <span class="report-desc">Listing of All Tickets that are past their Due Date.</span>
                <span class="report-name mt-3">Ticket Type Summary</span>
                <span class="report-desc">Summary of Ticket Types received for a date range and member codes.</span>
                <span class="report-name mt-3">Assignment Placement Summary </span>
                <span class="report-desc">Summary of tickets assigned to Locators.</span>
                <span class="report-name mt-3">Average Time to Locate</span>
                <span class="report-desc">Summary of average ticket response time.</span>
                <span class="report-name mt-3">Locator Productivity Detail</span>
                <span class="report-desc">Detail of Locator responses and units of work.</span>
                <span class="report-name mt-3">Locate Time</span>
                <span class="report-desc">Average Ticket Locate Time for each specified user, optionally filtered by member code, over a date range.</span>
            </v-col>
        </v-row> -->
        <v-row v-if="showSsrsReports">
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            >
                <h4>Tickets</h4>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('open-ticket-listing')"
                >Open Ticket Listing</span>
                <span class="report-desc">Listing of All Open Tickets.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('past-due-ticket-listing')"
                >Past Due Ticket Listing</span>
                <span class="report-desc">Listing of All Tickets that are past their Due Date.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('tickets-due-summary')"
                >Tickets Due Summary Listing</span>
                <span class="report-desc">Listing of All Tickets that are Due on a given Date.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('response-listing')"
                >Response Listing</span>
                <span class="report-desc">Listing of ticket responses for a date range, filtered by: Member Code, Locator, Response Code. Output order is by response date.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('ticket-responses-by-day-user-summary')"
                >Responses by User (Summary) </span>
                <span class="report-desc">Summary of ticket responses for a date range broken down by respondent.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('ticket-responses-by-day-user-detail')"
                >Responses by User (Detail)</span>
                <span class="report-desc">Listing of ticket responses for a date range broken down by respondent.</span>
                <span
                    class="report-name mt-3"
                    @click="openReportDialog('tickets-missing-excavator-destination')"
                >Open Tickets Missing Excavator Destination</span>
                <span class="report-desc">List of open tickets that do not have both an E-Mail and Cell number.</span>
                <!-- <span class="report-name mt-3">Locator Worksheet</span> -->
                <!-- <span class="report-desc">Locator Open Tickets Worksheet.</span> -->
            </v-col>
        </v-row>
        <v-row v-if="hasCoreReportPermission && coreReports.length">
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            >      
                <h4>Core</h4>
                <template>
                    <div
                        v-for="report in coreReports"
                        :key="report.id"
                    >
                        <div v-if="viewReportPermission(report)">
                            <span
                                class="report-name mt-3"
                                @click="openReportGeneratorDialog(report)"
                            >{{ report.title }}</span>
                            <span class="report-desc block">{{ report.description }}</span>
                        </div>
                    </div>           
                </template>
            </v-col>
        </v-row>
        <v-row v-if="hasCompanyPermission_USE_BILLING_MODULE && billingReports.length">
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            > 
                <h4>Billing</h4>
                <template>
                    <div
                        v-for="report in billingReports"
                        :key="report.id"
                    >
                        <div v-if="viewReportPermission(report)">
                            <span
                                class="report-name mt-3"
                                @click="openReportGeneratorDialog(report)"
                            >{{ report.title }}</span>
                            <span class="report-desc block">{{ report.description }}</span>                            
                        </div>
                    </div>           
                </template>                
            </v-col>
        </v-row>
        <v-row v-if="hasSystemReportPermission && systemReports.length">
            <v-col
                cols=""
                class="mx-7 my-2 report-section"
            >                       
                <h4>System</h4>
                <template>
                    <div
                        v-for="report in systemReports"
                        :key="report.id"
                    >
                        <div v-if="viewReportPermission(report)">                      
                            <span
                                class="report-name mt-3"
                                @click="openReportGeneratorDialog(report)"
                            >{{ report.title }}</span>
                            <span class="report-desc block">{{ report.description }}</span>                           
                        </div>  
                    </div>           
                </template>
            </v-col>
        </v-row>
        <!-- Used for the Legacy Reports-->
        <ReportDialog
            v-model="showReportDialog"
            :report-id="reportId"
        />
        <!-- Used for the Data Generated Reports-->
        <ReportGeneratorDialog
            v-if="Object.keys(report).length"
            v-model="showReportGeneratorDialog"
            :report="report"           
        />
    </v-container>
</template>

<script>

import ReportDialog from './ReportDialog.vue';
import ReportGeneratorDialog from './ReportGeneratorDialog.vue';
import { hasPermission } from '@/utils/permissions';
import { isTruthy } from '@/utils/isTruthy.js';

export default {
    name: 'Reports',
    components: {
        ReportDialog,
        ReportGeneratorDialog
    },
    data: () => ({
        reportId: '',
        report: {},
        showReportDialog: false,
        showReportGeneratorDialog: false,
    }),
    computed: {
        user() {
            return this.$store.getters.user;
        },
        hasCompanyPermission_USE_BILLING_MODULE() {
            return hasPermission('USE_BILLING_MODULE');
        },
        hasSystemReportPermission() {
            if (this.user.ingroup === 'SYSOP') {
                return true;
            }
            return false; 
        },
        hasCoreReportPermission() {
            return true; 
        },
        showSsrsReports() {
            let ssrsHideReports = this.$store.getters.systemVariables.find( v => v.name === 'SSRS_HIDE_REPORTS');
            if(ssrsHideReports) {
                if(isTruthy(ssrsHideReports.value)) {
                    return false;
                }
            }
            return true;
        },
        systemReports() {
            const sysReports = this.$store.getters.sysReports;
            const systemReports = sysReports.filter(report => report.module === 'SYSTEM');
            return systemReports;
        },
        coreReports() {
            const sysReports = this.$store.getters.sysReports;
            const coreReports = sysReports.filter(report => report.module === 'CORE');
            return coreReports;
        },
        billingReports() {
            const sysReports = this.$store.getters.sysReports;
            const billingReports = sysReports.filter(report => report.module === 'BILLING');
            return billingReports;
        },       

    },
    methods: {
        openReportDialog(reportId) {
            this.reportId = reportId;
            this.showReportDialog = true;
        },
        openReportGeneratorDialog(report) {
            this.report = report;
            this.showReportGeneratorDialog = true;
        },
        hasPermission(permission) {
            return hasPermission(permission);
        },
        viewReportPermission(report) {
            if (report?.permission_group_csv) {
                const permissionGroups = report.permission_group_csv.split(',');
                if(permissionGroups.length && permissionGroups.includes(this.user.ingroup)) {
                    return true;
                }
            }
            return false;
        }
    }    
};
</script>

<style scoped>
    .view-history-btn .v-btn__content {
        color: var(--ll-text-brand) !important;
    }
    .report-section {
        border: 1px solid #E6E6E6;
    }
    .report-name {
        font-size: 14px;
        color: #0D99FF;
        cursor: pointer;
        display: block;
        font-weight: bold;
    }
    .report-desc {
        font-size: 14px;
        color: #444444;
    }
    .block {
  display: block;
}
</style>
